import { Thumbmark } from "@thumbmarkjs/thumbmarkjs";

/**
 * Whether Smartlook session recording should be enabled.
 * Returns false when hostname contains localhost, .us, or .net.
 */
export function shouldRecordSmartlook() {
  if (typeof window === 'undefined') return false;
  const h = window.location.hostname;
  return !h.includes('localhost') && !h.includes('.us') && !h.includes('.net');
}

/**
 * @name isVoid 判断是不是个空值
 */
export function isVoid(value) {
  return ["", undefined, null].includes(value);
}

/**
 * @name getClientToken 获取客户端指纹
 */
export async function getClientToken() {
  try {
    if (window._K) return window._K;
    const token = await new Thumbmark().get();
    window._K = token.thumbmark;
    return window._K;
  } catch (error) {
    return "";
  }
}
